export const useResize = () => {
	const resizeObserver = (callback: () => void | Promise<void>) =>
		typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(e => e.map(callback));

	return {
		resizeObserver,
	};
};
